<template>
	<div class="fund_manage">
		<a-tabs :activeKey="activeKey" @change="handCut">
			<a-tab-pane tab="库存列表" key="1">
				<!-- 搜索 -->
				<div class="search">
					<a-form layout="inline" :form="searchForm1">
						<!-- <a-form-item><a-input allowClear style="width:240px;" placeholder="请输入商品编号" v-decorator="['pro_sNo']" /></a-form-item> -->

						<a-form-item><a-input allowClear style="width:240px;" placeholder="请输入商品名称" v-decorator="['product_title']" /></a-form-item>

						<a-form-item><a-button @click="resetGoods">重置</a-button></a-form-item>

						<a-form-item><a-button type="primary" html-type="submit" @click="searchAxios">查询</a-button></a-form-item>
					</a-form>
				</div>

				<!-- 操作栏 -->
				<div class="handle"><a-button @click="download">导出</a-button></div>
				
				<div id="tableHeight" style="flex: 1">
					<!-- 表格  -->
					<a-table v-if="tableHeight>0" :scroll="{ x: 1650, y: tableHeight }" :loading="loading" :columns="columns" :dataSource="dataSource" :pagination="pagination" @change="onChangeload">
						<div class="product_title" slot="product_title" slot-scope="text">
							<img :src="text.imgurl" class="table-imgurl" />
							<p>{{ text.product_title }}</p>
						</div>
						<div slot="specifications" slot-scope="text" style="width: 460px;word-break: break-all;white-space: break-spaces;">
							{{text}}
						</div>
						
						<span slot="status" slot-scope="text">
							<a-tag v-if="text == 2" color="#8BC34A">已上架</a-tag>
							<a-tag v-else-if="text == 3" color="#969DA8">已下架</a-tag>
							<a-tag v-else color="#969DA8">待上架</a-tag>
						</span>
	
						<span slot="num" slot-scope="text">
							<span v-if="text.num > text.min_inventory">{{ text.num }}</span>
							<span v-else style="color: #FC5454">{{ text.num }}</span>
						</span>
	
						<span slot="action" slot-scope="text">
							<div style="margin-bottom: 6px;"><a-button icon="eye" size="small" @click="onSee(text.id,text.pid)">库存详情</a-button></div>
	
							<div><a-button icon="plus" size="small" @click="addModal(text.id,text.pid)">添加库存</a-button></div>
						</span>
					</a-table>
				</div>
				
			</a-tab-pane>

			<a-tab-pane tab="库存预警" key="2">
				<!-- 搜索 -->
				<div class="search">
					<a-form layout="inline" :form="searchForm2">
						<!-- <a-form-item><a-input allowClear style="width:240px;" placeholder="请输入商品编号" v-decorator="['pro_sNo']" /></a-form-item> -->

						<a-form-item><a-input allowClear style="width:240px;" placeholder="请输入商品名称" v-decorator="['product_title']" /></a-form-item>

						<a-form-item><a-range-picker v-decorator="['date']" :placeholder="['请选择开始时间', '请选择结束时间']" /></a-form-item>

						<a-form-item><a-button @click="resetGoods">重置</a-button></a-form-item>

						<a-form-item><a-button type="primary" html-type="submit" @click="searchAxios">查询</a-button></a-form-item>
					</a-form>
				</div>

				<!-- 操作栏 -->
				<div class="handle"><a-button @click="download">导出</a-button></div>

				<!-- 表格  -->
				<a-table :scroll="tableScroll" :loading="loading" :columns="warnColumns" :dataSource="dataSource" :pagination="pagination" @change="onChangeload">
					<div class="product_title" slot="product_title" slot-scope="text">
						<img :src="text.imgurl" class="table-imgurl" />
						<p>{{ text.product_title }}</p>
					</div>

					<span slot="status" slot-scope="text">
						<a-tag v-if="text == 2" color="#8BC34A">已上架</a-tag>
						<a-tag v-else-if="text == 3" color="#969DA8">已下架</a-tag>
						<a-tag v-else color="#969DA8">待上架</a-tag>
					</span>

					<span slot="num" slot-scope="text">
						<span style="color: #FC5454">{{ text.num }}</span>
					</span>

					<span slot="action" slot-scope="text">
						<div style="margin-bottom: 6px;"><a-button icon="eye" size="small" @click="onSee(text.id,text.pid)">库存详情</a-button></div>

						<div><a-button icon="plus" size="small" @click="addModal(text.id,text.pid)">添加库存</a-button></div>
					</span>
				</a-table>
			</a-tab-pane>

			<a-tab-pane tab="入货详情" key="3">
				<!-- 搜索 -->
				<div class="search">
					<a-form layout="inline" :form="searchForm3">
						<!-- <a-form-item><a-input allowClear style="width:240px;" placeholder="请输入商品编号" v-decorator="['pro_sNo']" /></a-form-item> -->

						<a-form-item><a-input allowClear style="width:240px;" placeholder="请输入商品名称" v-decorator="['product_title']" /></a-form-item>

						<a-form-item><a-range-picker v-decorator="['date']" :placeholder="['请选择开始时间', '请选择结束时间']" /></a-form-item>

						<a-form-item><a-button @click="resetGoods">重置</a-button></a-form-item>

						<a-form-item><a-button type="primary" html-type="submit" @click="searchAxios">查询</a-button></a-form-item>
					</a-form>
				</div>

				<!-- 操作栏 -->
				<div class="handle"><a-button @click="download">导出</a-button></div>

				<!-- 表格  -->
				<a-table :scroll="tableScroll" :loading="loading" :columns="intoColumns" :dataSource="dataSource" :pagination="pagination" @change="onChangeload">
					<div class="product_title" slot="product_title" slot-scope="text">
						<img :src="text.imgurl" class="table-imgurl" />
						<p>{{ text.product_title }}</p>
					</div>

					<span slot="status" slot-scope="text">
						<a-tag v-if="text == 2" color="#8BC34A">已上架</a-tag>
						<a-tag v-else-if="text == 3" color="#969DA8">已下架</a-tag>
						<a-tag v-else color="#969DA8">待上架</a-tag>
					</span>

					<span slot="action" slot-scope="text">
						<div style="margin-bottom: 6px;"><a-button icon="eye" size="small">库存详情</a-button></div>

						<div><a-button icon="plus" size="small">添加库存</a-button></div>
					</span>
				</a-table>
			</a-tab-pane>

			<a-tab-pane tab="出货详情" key="4">
				<!-- 搜索 -->
				<div class="search">
					<a-form layout="inline" :form="searchForm4">
						<!-- <a-form-item><a-input allowClear style="width:240px;" placeholder="请输入商品编号" v-decorator="['pro_sNo']" /></a-form-item> -->

						<a-form-item><a-input allowClear style="width:240px;" placeholder="请输入商品名称" v-decorator="['product_title']" /></a-form-item>

						<a-form-item><a-range-picker v-decorator="['date']" :placeholder="['请选择开始时间', '请选择结束时间']" /></a-form-item>

						<a-form-item><a-button @click="resetGoods">重置</a-button></a-form-item>

						<a-form-item><a-button type="primary" html-type="submit" @click="searchAxios">查询</a-button></a-form-item>
					</a-form>
				</div>

				<!-- 操作栏 -->
				<div class="handle"><a-button @click="download">导出</a-button></div>

				<!-- 表格  -->
				<a-table :scroll="tableScroll" :loading="loading" :columns="shipmentColumns" :dataSource="dataSource" :pagination="pagination" @change="onChangeload">
					<div class="product_title" slot="product_title" slot-scope="text">
						<img :src="text.imgurl" class="table-imgurl" />
						<p>{{ text.product_title }}</p>
					</div>

					<span slot="status" slot-scope="text">
						<a-tag v-if="text == 2" color="#8BC34A">已上架</a-tag>
						<a-tag v-else-if="text == 3" color="#969DA8">已下架</a-tag>
						<a-tag v-else color="#969DA8">待上架</a-tag>
					</span>

					<span slot="action" slot-scope="text">
						<div style="margin-bottom: 6px;"><a-button icon="eye" size="small">库存详情</a-button></div>

						<div><a-button icon="plus" size="small">添加库存</a-button></div>
					</span>
				</a-table>
			</a-tab-pane>
		</a-tabs>

		<!-- 导出 -->
		<a-modal v-model="visible1" title="导出数据" :footer="null" width="540px">
			<div class="derive">
				<div @click="onDownload('This_page')">
					<a-icon type="file-text" style="font-size:26px;" />
					<div>导出本页</div>
				</div>

				<div @click="onDownload('whole')">
					<a-icon type="snippets" style="font-size:26px;" />
					<div>导出全部</div>
				</div>

				<div @click="onDownload('inquiry')">
					<a-icon type="file-search" style="font-size:26px;" />
					<div>导出查询</div>
				</div>
			</div>
		</a-modal>

		<!-- 添加库存 -->
		<a-modal v-model="addKucunFlag" title="添加库存" width="540px" @ok="addKucunOk">
			<div class="addkucun">
				<div class="addkucun_item">
					<div class="addkucun_item_left">
						<span style="color: #FF3333;">*</span>
						增加库存：
					</div>

					<div class="addkucun_item_right"><a-input allowClear style="width:290px;" placeholder="请输入增加的库存量" v-model="addKucunNum" /></div>
				</div>
				<div class="addkucun_item">
					<div class="addkucun_item_left">总库存：</div>

					<div class="addkucun_item_right">{{addkucunObj.total_num}}</div>
				</div>
				<div class="addkucun_item">
					<div class="addkucun_item_left">剩余库存：</div>

					<div class="addkucun_item_right">{{addkucunObj.num}}</div>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
const columns = [
	{
		title: '序号',
		key: 'id',
		dataIndex: 'id',
		fixed: 'left',
		width: 70
	},
	// {
	// 	title: '商品编号',
	// 	key: 'product_number',
	// 	dataIndex: 'product_number'
	// },
	{
		title: '商品名称',
		key: 'product_title',
		scopedSlots: { customRender: 'product_title' },
		width: 270
	},
	{
		title: '商品状态',
		key: 'status',
		dataIndex: 'status',
		scopedSlots: { customRender: 'status' },
		width: 120
	},
	{
		title: '规格',
		key: 'specifications',
		dataIndex: 'specifications',
		scopedSlots: { customRender: 'specifications' },
		width: 500
	},
	{
		title: '售价',
		key: 'price',
		dataIndex: 'price',
		width: 120
	},
	{
		title: '总库存',
		key: 'total_num',
		dataIndex: 'total_num',
		width: 120
	},
	{
		title: '剩余库存',
		key: 'num',
		scopedSlots: { customRender: 'num' },
		width: 120
	},
	{
		title: '上架时间',
		key: 'upper_shelf_time',
		dataIndex: 'upper_shelf_time',
		width: 200
	},
	{
		title: '操作',
		key: 'action',
		scopedSlots: { customRender: 'action' },
		fixed: 'right',
		width: 130
	}
];

const warnColumns = [
	{
		title: '序号',
		key: 'id',
		dataIndex: 'id',
		fixed: 'left',
		width: '70px'
	},
	// {
	// 	title: '商品编号',
	// 	key: 'product_number',
	// 	dataIndex: 'product_number'
	// },
	{
		title: '商品名称',
		key: 'product_title',
		scopedSlots: { customRender: 'product_title' },
		width: '270px'
	},
	{
		title: '商品状态',
		key: 'status',
		dataIndex: 'status',
		scopedSlots: { customRender: 'status' },
		width: '120px'
	},
	{
		title: '规格',
		key: 'specifications',
		dataIndex: 'specifications',
		width: '200px'
	},
	{
		title: '售价',
		key: 'price',
		dataIndex: 'price',
		width: '120px'
	},
	{
		title: '总库存',
		key: 'total_num',
		dataIndex: 'total_num',
		width: '120px'
	},
	{
		title: '剩余库存',
		key: 'num',
		scopedSlots: { customRender: 'num' },
		width: '120px'
	},
	{
		title: '预警时间',
		key: 'add_date',
		dataIndex: 'add_date',
		width: '160px'
	},
	{
		title: '操作',
		key: 'action',
		scopedSlots: { customRender: 'action' },
		fixed: 'right',
		width: 130
	}
];

const intoColumns = [
	{
		title: '序号',
		key: 'id',
		dataIndex: 'id',
		fixed: 'left',
		width: '70px'
	},
	{
		title: '商品名称',
		key: 'product_title',
		scopedSlots: { customRender: 'product_title' },
		width: '270px'
	},
	{
		title: '商品状态',
		key: 'status',
		dataIndex: 'status',
		scopedSlots: { customRender: 'status' },
		width: '120px'
	},
	{
		title: '规格',
		key: 'specifications',
		dataIndex: 'specifications',
		width: '200px'
	},
	{
		title: '售价',
		key: 'price',
		dataIndex: 'price',
		width: '150px'
	},
	{
		title: '入库量',
		key: 'flowing_num',
		dataIndex: 'flowing_num',
		width: '150px'
	},
	{
		title: '入库时间',
		key: 'add_date',
		dataIndex: 'add_date',
		width: '160px',
		fixed: 'right'
	}
];

const shipmentColumns = [
	{
		title: '序号',
		key: 'id',
		dataIndex: 'id',
		fixed: 'left',
		width: '70px'
	},
	{
		title: '商品名称',
		key: 'product_title',
		scopedSlots: { customRender: 'product_title' },
		width: '270px'
	},
	{
		title: '商品状态',
		key: 'status',
		dataIndex: 'status',
		scopedSlots: { customRender: 'status' },
		width: '120px'
	},
	{
		title: '规格',
		key: 'specifications',
		dataIndex: 'specifications',
		width: '200px'
	},
	{
		title: '售价',
		key: 'price',
		dataIndex: 'price',
		width: '150px'
	},
	{
		title: '出库量',
		key: 'flowing_num',
		dataIndex: 'flowing_num',
		width: '150px'
	},
	{
		title: '出库时间',
		key: 'add_date',
		dataIndex: 'add_date',
		width: '160px',
		fixed: 'right'
	}
];

export default {
	data() {
		return {
			activeKey: '1', //tabs默认选中的
			loading: true,
			columns,
			warnColumns,
			intoColumns,
			shipmentColumns,
			dataSource: [],
			visible: false,
			// 搜索表单
			searchForm1: this.$form.createForm(this, { name: 'searchForm1' }),
			searchForm2: this.$form.createForm(this, { name: 'searchForm2' }),
			searchForm3: this.$form.createForm(this, { name: 'searchForm3' }),
			searchForm4: this.$form.createForm(this, { name: 'searchForm4' }),
			
			labelCol: {
				xs: { span: 24 },
				sm: { span: 5 }
			},
			wrapperCol: {
				xs: { span: 24 },
				sm: { span: 12 }
			},
			
			tableScroll: {},

			pagination: {
				current: 1,
				page: 1,
				pagesize: 10,
				total: 0
			},

			urls: '',
			visible1: false,
			searchData: {},

			addKucunFlag: false,
			addKucunNum: '',
			addKucunId: '',
			addKucunPid: '',
			addkucunObj: {},
			
			tableHeight: 0
		};
	},
	watch: {
		addKucunFlag(flag) {
			if (!flag) {
				this.addKucunNum = '';
			}
		}
	},
	mounted() {
		
		document.getElementsByClassName('ant-tabs-content')[0].style.flex = '1'
		document.getElementsByClassName('ant-tabs-content')[0].style.marginLeft = '0'
		document.getElementsByClassName('ant-tabs-content')[0].style.overflow = 'hidden'
		
		document.getElementsByClassName('ant-tabs-tabpane')[0].style.display = 'flex'
		document.getElementsByClassName('ant-tabs-tabpane')[0].style.flexDirection = 'column'
		
		setTimeout(()=>{
			let height = document.getElementById('tableHeight').offsetHeight
			console.log(height)
			console.log(this.tableScroll.x)
			this.tableHeight = height-120
			this.tableScroll = { x: 1310, y: height-120 }
			
			
			document.getElementsByClassName('ant-tabs-content')[0].style.overflow = 'visible'
		},100)
		
		this.axios();
	},
	methods: {
		addModal(id,pid) {
			let data = {
				id, // 商品属性id
				pid // 商品id
			}
			
			let url = '?module=pc_api&action=product&app=add_stock_page';
			
			this.$request.post(url, data).then(res => {
				let { code, message, data } = res;
			
				if (code === 200) {
					this.addKucunPid = pid
					this.addKucunId = id;
					this.addKucunFlag = true;
					
					this.addkucunObj = {
						...data
					}
					
				} else {
					this.$message.error(message);
				}
			});
			
		},
		addKucunOk() {
			let data = {
				id: this.addKucunId, // 商品属性id
				pid: this.addKucunPid ,// 商品id
				add_num: this.addKucunNum,
				...this.addkucunObj
			}
			
			let url = '?module=pc_api&action=product&app=add_stock';
			
			this.$request.post(url, data).then(res => {
				let { code, message, data } = res;
			
				if (code == 200) {
					this.$message.success(message);
					this.addKucunFlag = false;
					
					setTimeout(()=>{
						this.axios()
					})
				} else {
					this.$message.error(message);
				}
			});
			
		},
		onSee(id,pid) {
			this.$router.push({ path: 'inventory/see' + '?tab=' + this.activeKey + '&id=' + id + '&pid=' + pid });
		},
		/**
		 * @name 导出
		 * */

		download() {
			let url = ''
			if (this.activeKey == 1) {
				url = '?module=pc_api&action=product&app=stock_list&pageto='
			} else if (this.activeKey == 2) {
				url = '?module=pc_api&action=product&app=stock_Warning&pageto='
			} else if (this.activeKey == 3) {
				url = '?module=pc_api&action=product&app=stock_Enter&pageto='
			} else if (this.activeKey == 4) {
				url = '?module=pc_api&action=product&app=stock_Shipment&pageto='
			}
			
			this.urls = url
			
			this.visible1 = !this.visible1;
		},
		/**
		 * @name 导出
		 */
		onDownload(pageto) {
			this.searchData.page = this.pagination.page
			this.$request.download(this.urls + pageto, this.searchData);
		},

		// 重置搜索
		resetGoods() {
			this.searchForm1.resetFields();
			this.searchForm2.resetFields();
			this.searchForm3.resetFields();
			this.searchForm4.resetFields();
		},
		
		// 搜索
		searchAxios(){
			let searchForm = ''
			if(this.activeKey == 1){
				searchForm = 'searchForm1'
			}else if(this.activeKey == 2){
				searchForm = 'searchForm2'
			}else if(this.activeKey == 3){
				searchForm = 'searchForm3'
			}else if(this.activeKey == 4){
				searchForm = 'searchForm4'
			}
			
			this[searchForm].validateFields((err, values) => {
				if (!err) {
					if (values.date && values.date.length) {
						values.startdate = values.date[0].format('YYYY-MM-DD HH:mm:ss');
						values.enddate = values.date[1].format('YYYY-MM-DD HH:mm:ss');
					} else {
						values.startdate = '';
						values.enddate = '';
					}
			
					this.searchData = values;
			
					this.pagination = {
						current: 1,
						page: 1,
						pagesize: 10,
						total: 0
					}
					
					this.axios();
				}
			});
		},
		
		// 搜索
		axios() {
			this.loading = true;
			
			let data = {
				...this.pagination,
				...this.searchData
			};
			
			let url = '';
			if (this.activeKey == 1) {
				url = '?module=pc_api&action=product&app=stock_list'
			} else if (this.activeKey == 2) {
				url = '?module=pc_api&action=product&app=stock_Warning'
			} else if (this.activeKey == 3) {
				url = '?module=pc_api&action=product&app=stock_Enter'
			} else if (this.activeKey == 4) {
				url = '?module=pc_api&action=product&app=stock_Shipment'
			}
			
			this.$request.post(url, data).then(res => {
				let { code, message, data } = res;
			
				if (code === 200) {
					this.pagination.total = Number(res.data.total)
					
					if(data.list){
						data.list.filter(item=>{
							if(!item.num){
								item.num = 0
							}
						})
					}
					
					this.dataSource = data.list;
					
					setTimeout(() => {
						this.loading = false;
					}, 800);
				} else {
					this.$message.error(message);
			
					setTimeout(() => {
						this.loading = false;
					}, 800);
				}
			});
		},

		onChangeload(e) {
			console.log(111)
			this.pagination.page = e.current;
			this.pagination.current = e.current;
			console.log(this.pagination)
			this.loading = true;
			this.axios();
		},

		handCut(e) {
			this.activeKey = e;
			
			if(e == 1 || e == 2){
				this.tableScroll.x = 1310
			}else{
				this.tableScroll.x = 1120
			}
			
			this.searchForm1.resetFields();
			this.searchForm2.resetFields();
			this.searchForm3.resetFields();
			this.searchForm4.resetFields();
			
			this.pagination = {
				current: 1,
				page: 1,
				pagesize: 10,
				total: 0
			}
			this.searchData = {};
			this.dataSource = [];
			
			this.loading = true;
			this.axios()
		}
	}
};
</script>
<style lang="less">
.derive {
	height: 200px;
	display: flex;
	justify-content: space-around;
	align-items: center;
	> div {
		width: 100px;
		height: 100px;
		border: 1px solid #03a2f4;
		border-radius: 4px;
		color: #03a2f4;
		font-size: 14px;
		transition: background-color 0.5s;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-evenly;
		cursor: pointer;
	}

	> div:hover {
		border: 0px solid #03a2f4;
		color: #ffffff;
		background: #2890ff;
	}
}
.fund_manage {
	height: 100%;
	
	.ant-tabs{
		display: flex;
		flex-direction: column;
		height: 100%;
	}
	
	.search {
		padding: 8px 32px;
	}

	.handle {
		padding: 0px 32px;
		padding-bottom: 8px;
		display: flex;
		align-items: center;
	}
	.difference {
		margin-right: 20px;
		.balance {
			font-size: 16px;
			color: #1e202c;
			margin-right: 20px;

			span {
				color: #03a2f4;
			}
		}
	}

	.table-imgurl {
		width: 60px;
		height: 60px;
	}
}

.reasonMask {
	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	z-index: 9999;

	> div {
		width: 460px;
		height: 278px;
		background: #ffffff;
		border-radius: 4px;

		.reasonMask_title {
			display: flex;
			justify-content: space-between;
			align-items: center;
			height: 60px;
			padding: 0 20px;
			box-sizing: border-box;
			border-bottom: 2px solid #e9ebef;
			font-size: 16px;
			font-weight: bold;
			color: #1e202c;
		}

		.reasonMask_content {
			display: flex;
			height: 149px;
			padding: 40px;
			font-size: 14px;
			color: #323543;

			&_left {
				width: 70px;
			}

			&_right {
				flex: 1;
				overflow: hidden auto;
			}
		}

		.reasonMask_bottom {
			height: 69px;
			border-top: 1px solid #e9ebef;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			padding: 0 20px;

			div {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 112px;
				height: 36px;
				background: #03a1f3;
				border-radius: 2px;
				color: #ffffff;
				cursor: pointer;
			}
		}
	}
}

.product_title {
	display: flex;
	align-items: center;
	width: 230px;

	p {
		flex: 1;
		margin-left: 10px;
		margin-bottom: 0;
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
	}
}

.addkucun {
	display: flex;
	flex-direction: column;

	&_item {
		display: flex;
		font-size: 14px;
		color: #323544;
		line-height: 36px;

		&_left {
			width: 85px;
			text-align: right;
			margin-right: 5px;
		}
	}
}

.ant-tabs .ant-tabs-top-content > .ant-tabs-tabpane, .ant-tabs .ant-tabs-bottom-content > .ant-tabs-tabpane{
	display: flex;
	flex-direction: column;
}

.ant-table-header{
	background-color: #FFFFFF;
}
</style>
